module.exports = __webpack_public_path__ + "icon-material-close.d0b86addcc37eb5e163c.svg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/assets/images/icon-material-close.svg
// module id = ../../../../../src/assets/images/icon-material-close.svg
// module chunks = 2